import React from "react";

const ChillerTruckOperations = ({ title, operations }) => {
  return (
    <section className="ct-operations-section">
      <div className="container">
        <div
          className="text-center"
          data-aos="fade-up"
          data-aos-duration="800"
          data-aos-once="true"
        >
          <h2>{title}</h2>
        </div>

        <div className="row g-4 mt-2">
          {operations.map((op, i) => (
            <div
              key={i}
              className="col-sm-6 col-lg-4"
              data-aos="fade-up"
              data-aos-delay={`${i * 100}`}
              data-aos-duration="700"
              data-aos-once="true"
            >
              <div className="ct-operations-card">
                <i className={`bi ${op.icon} ct-operations-icon`}></i>
                <p className="ct-operations-card-title">{op.title}</p>
                <p>{op.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ChillerTruckOperations;
